/**
 * MS Cart Link Disabler
========================
 * Disables product links in cart for:
 * 1. Items tagged with "kind:spirit"
 * 2. Back customization products (Custom...Back in title)
 * 3. Front products that have a paired back product in cart
 * Prevents customers from clicking back to product pages to modify
 * They can only adjust quantity or delete items
 *
 * SCOPE: Only runs on /cart page
 */
(function(){
  'use strict';

  if (window.location.pathname !== '/cart') return;

  var DEBUG = false;

  function log(){
    if (!DEBUG) return;
    console.log.apply(console, ['[Cart Link Disabler]'].concat(Array.prototype.slice.call(arguments)));
  }

  /* -- Get cart data to check tags -- */
  function getCart(){
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r){ return r.json(); });
  }

  /* -- Check if item has spirit tag -- */
  function hasSpiritTag(tags){
    if (!tags) return false;
    var tagArray = typeof tags === 'string' ? tags.split(',').map(function(t){ return t.trim(); }) : tags;
    for (var i = 0; i < tagArray.length; i++) {
      if (tagArray[i].toLowerCase() === 'kind:spirit') return true;
    }
    return false;
  }

  /* -- Check if item is a back customization product -- */
  function isBackProduct(item){
    var title = (item.title || '').toLowerCase();
    return title.indexOf('custom') !== -1 && title.indexOf('back') !== -1;
  }

  /* -- Check if item is a front product that has a paired back in cart -- */
  function hasPairedBack(item, allItems){
    if (isBackProduct(item)) return false; // Skip if this is already a back product
    
    var itemColor = getItemColor(item);
    if (!itemColor) return false;
    
    // Check if any back product in cart matches this front's color
    for (var i = 0; i < allItems.length; i++) {
      if (isBackProduct(allItems[i])) {
        var backColor = getItemColor(allItems[i]);
        if (backColor && backColor === itemColor) {
          return true;
        }
      }
    }
    return false;
  }

  /* -- Get color from item -- */
  function getItemColor(item){
    // From variant_title (front items)
    if (item.variant_title) {
      var parts = item.variant_title.split('/');
      if (parts.length > 0) {
        return parts[0].toLowerCase().trim();
      }
    }
    
    // From properties (back items)
    if (item.properties) {
      var colorVal = item.properties['Color'] || item.properties['color'] || item.properties['_ms_color'] || '';
      if (colorVal) return colorVal.toLowerCase().trim();
    }
    
    return '';
  }

  /* -- Disable links for specific cart items -- */
  function disableLinks(){
    getCart().then(function(cart){
      log('Cart items:', cart.items.length);

      cart.items.forEach(function(item, index){
        var lineNumber = index + 1;
        
        var shouldDisable = hasSpiritTag(item.tags) || isBackProduct(item) || hasPairedBack(item, cart.items);
        
        if (shouldDisable) {
          var itemType = hasSpiritTag(item.tags) ? 'spirit' : 
                        isBackProduct(item) ? 'back customization' : 
                        'front with paired back';
          log('Disabling links for ' + itemType + ' item:', item.title);

          // Find the cart item element (both cart page and drawer)
          var cartItem = document.getElementById('CartItem-' + lineNumber) || 
                         document.getElementById('CartDrawer-Item-' + lineNumber);
          
          if (!cartItem) return;

          // Find all links within this cart item
          var links = cartItem.querySelectorAll('a');
          
          links.forEach(function(link){
            // Check if this link goes to the product page
            var href = link.getAttribute('href') || '';
            if (href.indexOf('/products/') !== -1) {
              // Disable the link
              link.style.pointerEvents = 'none';
              link.style.cursor = 'default';
              link.style.textDecoration = 'none';
              
              // Prevent click
              link.addEventListener('click', function(e){
                e.preventDefault();
                e.stopPropagation();
                return false;
              }, true);

              // Add visual indicator (optional - makes text appear non-clickable)
              link.style.color = 'inherit';
              
              log('Disabled link:', href);
            }
          });
        }
      });
    }).catch(function(err){
      console.error('[Cart Link Disabler] Error:', err);
    });
  }

  /* -- Run on page load -- */
  function init(){
    disableLinks();
  }

  /* -- Watch for cart updates and re-apply -- */
  var observer = new MutationObserver(function(mutations){
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].type !== 'childList' || !mutations[i].addedNodes.length) continue;
      for (var j = 0; j < mutations[i].addedNodes.length; j++) {
        var node = mutations[i].addedNodes[j];
        if (node.nodeType === 1 && (
          node.id === 'cart' ||
          (node.classList && node.classList.contains('cart-items')) ||
          (node.id && node.id.indexOf('CartItem-') === 0) ||
          (node.id && node.id.indexOf('shopify-section-') === 0)
        )) {
          setTimeout(disableLinks, 300);
          return;
        }
      }
    }
  });

  var mainContent = document.getElementById('MainContent') || document.body;
  observer.observe(mainContent, { childList: true, subtree: true });

  /* -- Initialize after DOM and cart are ready -- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Also run after short delays to catch dynamic content
  setTimeout(init, 500);
  setTimeout(init, 1500);

  log('Cart Link Disabler initialized');
})();
